import React from "react";
import styled from "styled-components";
import { Title } from "../../components/MiniComponents";
import { Icon } from "../../components/MiniComponents";
import logoFb from '../../assets/img/fb.png';
import logoInsta from '../../assets/img/insta.png';
import logoTwitter from '../../assets/img/twitter.png';
import mailIcon from '../../assets/img/mail.png';

const ContactRoot = styled.section`
    text-align: center;
    padding: 2em 0;
`;

const Contact = () => {
    return (
        <ContactRoot id="contact">
            <Title>Contact</Title>
            <nav>
                <div>Retrouvez-nous sur les réseaux sociaux !</div>
                <br/>
                <div>
                    <a href="https://www.instagram.com/farlandsstudio/"><Icon src={logoInsta}></Icon></a>
                    <a href="https://www.facebook.com/FarlandsStudio"><Icon src={logoFb}></Icon></a>
                    <a href="https://twitter.com/FarlandsStudio"><Icon src={logoTwitter}></Icon></a>
                    <a href="mailto:farlands.indiegames@gmail.com"><Icon src={mailIcon}></Icon></a>
                </div>
            </nav>
        </ContactRoot>
    )
};
export default Contact;



// WEBPACK FOOTER //
// ./src/pages/Contact/Contact.jsx